export default "__VITE_ASSET__d9QaJTiPH4fXgPH4OnM3hQ__";